import { analyticsClient } from '../lib/client';
import { RUBRIC_ROUTES } from './routes';
import type {
    RubricRequest,
    RubricResponse,
    RubricsResponse,
    DeleteRubricResponse
} from './types';

export const createRubric = async (data: RubricRequest) => {
    try {
        const response = await analyticsClient.post<RubricResponse>(
            RUBRIC_ROUTES.CREATE,
            data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to create rubric' };
    }
};

export const getRubrics = async () => {
    try {
        const response = await analyticsClient.get<RubricsResponse>(
            RUBRIC_ROUTES.GET_ALL
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch rubrics' };
    }
};

export const getRubricById = async (id: string) => {
    try {
        const response = await analyticsClient.get<RubricResponse>(
            RUBRIC_ROUTES.GET_BY_ID(id)
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch rubric' };
    }
};

export const updateRubric = async (id: string, data: Partial<RubricRequest>) => {
    try {
        const response = await analyticsClient.patch<RubricResponse>(
            RUBRIC_ROUTES.UPDATE(id),
            data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to update rubric' };
    }
};

export const deleteRubric = async (id: string) => {
    try {
        const response = await analyticsClient.delete<DeleteRubricResponse>(
            RUBRIC_ROUTES.DELETE(id)
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to delete rubric' };
    }
};
